<template>
  <div class="mt-root">
    <div class="mt-row" :class="{ 'mt-row--stack': !showBorrower || !showLoan }">
      <div v-if="showBorrower" class="mt-group">
        <div class="mt-grid mt-grid--3">
          <button class="mt-mini" @click="openBorrowerOutstanding">
            <div class="mt-mini__icon mt-mini__icon--red">
              <i class="fa-solid fa-file-circle-exclamation"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Outstanding</div>
              <div class="mt-mini__value">{{ borrowerCounts.outstanding }}</div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button>

          <button class="mt-mini" @click="openBorrowerPending">
            <div class="mt-mini__icon mt-mini__icon--amber">
              <i class="fa-solid fa-hourglass-half"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Pending</div>
              <div class="mt-mini__value">{{ borrowerCounts.pending }}</div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button>

          <button class="mt-mini" @click="openBorrowerSignature">
            <div class="mt-mini__icon mt-mini__icon--green">
              <i class="fa-solid fa-signature"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Pending Sign.</div>
              <div class="mt-mini__value">{{ borrowerCounts.signature }}</div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button>
        </div>
      </div>

      <div v-if="showLoan" class="mt-group" :class="{ divider: showBorrower }">
        <div class="mt-grid mt-grid--6">
          <button class="mt-mini" :disabled="isLoanLoading" @click="openLoanDueToday">
            <div class="mt-mini__icon mt-mini__icon--blue">
              <i class="fa-solid fa-calendar-day"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Due Today</div>
              <div class="mt-mini__value">
                <span v-if="isLoanLoading" class="mt-skel mt-skel--num" :style="skelStyle(skelWidths.dueToday)"></span>
                <span v-else>{{ loanCounts.dueToday }}</span>
              </div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button>

          <!-- <button class="mt-mini" :disabled="isLoanLoading" @click="openLoanOpen">
            <div class="mt-mini__icon mt-mini__icon--amber">
              <i class="fa-solid fa-folder-open"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Open</div>
              <div class="mt-mini__value">
                <span v-if="isLoanLoading" class="mt-skel mt-skel--num" :style="skelStyle(skelWidths.open)"></span>
                <span v-else>{{ loanCounts.open }}</span>
              </div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button> -->

          <button class="mt-mini" :disabled="isLoanLoading" @click="openLoanOutstanding">
            <div class="mt-mini__icon mt-mini__icon--purple">
              <i class="fa-solid fa-circle-exclamation"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Outstanding</div>
              <div class="mt-mini__value">
                <span
                  v-if="isLoanLoading"
                  class="mt-skel mt-skel--num"
                  :style="skelStyle(skelWidths.outstanding)"
                ></span>
                <span v-else>{{ loanCounts.outstanding }}</span>
              </div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button>
<!-- 
          <button class="mt-mini" :disabled="isLoanLoading" @click="openLoanAssigned">
            <div class="mt-mini__icon mt-mini__icon--teal">
              <i class="fa-solid fa-user-check"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Assigned</div>
              <div class="mt-mini__value">
                <span
                  v-if="isLoanLoading"
                  class="mt-skel mt-skel--num"
                  :style="skelStyle(skelWidths.assigned)"
                ></span>
                <span v-else>{{ loanCounts.assigned }}</span>
              </div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button> -->

          <button class="mt-mini" :disabled="isLoanLoading" @click="openLoanTeam">
            <div class="mt-mini__icon mt-mini__icon--green">
              <i class="fa-solid fa-users"></i>
            </div>
            <div class="mt-mini__meta">
              <div class="mt-mini__label">Team</div>
              <div class="mt-mini__value">
                <span v-if="isLoanLoading" class="mt-skel mt-skel--num" :style="skelStyle(skelWidths.team)"></span>
                <span v-else>{{ loanCounts.team }}</span>
              </div>
            </div>
            <i class="fa-solid fa-chevron-right mt-mini__chev"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from "@/api/api.service.js"
import { isToday, isPastDue } from "@/helpers/formatters.js"

export default {
  name: "MyTasksCard",
  props: {
    azureId: { type: String, required: true },
    accessToken: { type: String, required: true },
    taskSwitchChecked: { type: Boolean, default: false },
    openTaskColumns: { type: Array, required: true },
    internalTaskColumns: { type: Array, required: true },
    section: {
      type: String,
      default: "both",
      validator: v => ["both", "borrower", "loan"].includes(v)
    }
  },
  emits: ["open-grid"],
  data() {
    return {
      isLoanLoading: false,
      skelWidths: { dueToday: 26, pastDue: 26, open: 26, outstanding: 26, assigned: 26, team: 26 },

      openTaskRequested: [],
      openTaskPending: [],
      openSigningTaskData: [],

      openTaskRequestedTotal: 0,
      openTaskPendingTotal: 0,
      openSigningTaskTotal: 0,

      internalTaskPending: [],
      internalTaskRequested: [],
      followUpToday: [],
      pastDue: [],
      tasksIAssigned: [],
      teamTasks: [],

      internalTaskPendingTotal: 0,
      internalTaskRequestedTotal: 0,
      followUpTodayTotal: 0,
      pastDueTotal: 0,
      tasksIAssignedTotal: 0,
      teamTasksTotal: 0
    }
  },
  computed: {
    showBorrower() {
      return this.section === "both" || this.section === "borrower"
    },
    showLoan() {
      return this.section === "both" || this.section === "loan"
    },
    borrowerCounts() {
      return {
        outstanding: this.openTaskRequestedTotal,
        pending: this.openTaskPendingTotal,
        signature: this.openSigningTaskTotal
      }
    },
    loanCounts() {
      return {
        dueToday: this.followUpTodayTotal,
        pastDue: this.pastDueTotal,
        open: this.internalTaskPendingTotal,
        outstanding: this.internalTaskRequestedTotal,
        assigned: this.tasksIAssignedTotal,
        team: this.teamTasksTotal
      }
    }
  },
watch: {
  async taskSwitchChecked() {
    this.captureSkelWidths()
    await Promise.all([
      this.fetchBorrowerTasks(),
      this.fetchInternalTasks(true)
    ])
  }
},
  methods: {
    skelStyle(px) {
      return { width: px + "px" }
    },

    captureSkelWidths() {
      const map = {
        dueToday: this.loanCounts.dueToday,
        pastDue: this.loanCounts.pastDue,
        open: this.loanCounts.open,
        outstanding: this.loanCounts.outstanding,
        assigned: this.loanCounts.assigned,
        team: this.loanCounts.team
      }

      const min = 18
      const max = 52
      const perDigit = 12
      const base = 14

      for (const k of Object.keys(map)) {
        const val = map[k]
        const digits = String(val ?? 0).length
        const w = Math.min(max, Math.max(min, base + digits * perDigit))
        this.skelWidths[k] = w
      }
    },

    cleanText(v) {
      if (v == null) return ""
      const s = String(v).trim()
      if (!s) return ""
      const low = s.toLowerCase()
      if (low === "undefined" || low === "null") return ""
      return s
    },

    getLoanNumber(item) {
      return this.cleanText(item?.loannumber || item?.f364 || "")
    },

    getBorrowerName(item) {
      return this.cleanText(item?.borrowername || item?.borrower_name || "—") || "—"
    },

    groupByLoanBorrower(items) {
      const map = new Map()

      for (const t of items || []) {
        const loanNumber = this.getLoanNumber(t) || "—"
        const borrower = this.getBorrowerName(t) || "—"
        const key = `${loanNumber}__${borrower}`

        if (!map.has(key)) {
          map.set(key, { loanNumber, borrowers: [borrower], tasks: [] })
        }

        map.get(key).tasks.push(t)
      }

      return Array.from(map.values()).sort((a, b) => {
        const la = String(a.loanNumber || "")
        const lb = String(b.loanNumber || "")
        if (la !== lb) return la.localeCompare(lb)
        const ba = String((a.borrowers || [])[0] || "")
        const bb = String((b.borrowers || [])[0] || "")
        return ba.localeCompare(bb)
      })
    },

    async refreshAll() {
      await this.fetchBorrowerTasks()
      await this.fetchInternalTasks(false)
      await this.fetchTasksIAssigned()
      await this.fetchTeamTasks()
    },

   async fetchBorrowerTasks() {
  const res = await apiService.GetSwiftDashboardData(
    this.azureId,
    this.taskSwitchChecked,
    this.taskSwitchChecked,
    this.accessToken
  )

  const openTaskData = res?.data?.data?.data ?? res?.data?.data ?? []

  this.openTaskRequested = []
  this.openTaskPending = []
  this.openSigningTaskData = []

  for (let i = openTaskData.length - 1; i >= 0; i--) {
    const item = openTaskData[i]
    item.created = item.created ? new Date(item.created) : null
    item.cust17fv = item.cust17fv ? new Date(item.cust17fv) : null

    if (item.status === "Pending") this.openTaskPending.unshift(item)
    else if (item.status === "Requested" && item.signingtask === "True") this.openSigningTaskData.unshift(item)
    else if (item.status === "Requested" && item.signingtask === "False") this.openTaskRequested.unshift(item)
  }

  this.openTaskRequestedTotal = this.openTaskRequested.length
  this.openTaskPendingTotal = this.openTaskPending.length
  this.openSigningTaskTotal = this.openSigningTaskData.length
},

    async fetchInternalTasks(showLoader = false) {
      let timer
      if (showLoader) {
        timer = setTimeout(() => {
          this.isLoanLoading = true
        }, 120)
      }

      try {
        let res
        if (this.taskSwitchChecked) res = await apiService.GetInternalTasksByOrgId(this.azureId, this.accessToken)
        else res = await apiService.GetInternalTasks(this.azureId, this.accessToken)

        const data = res?.data?.data?.data ?? res?.data?.data ?? []

        this.internalTaskPending = []
        this.internalTaskRequested = []
        this.followUpToday = []
        this.pastDue = []

        for (let i = data.length - 1; i >= 0; i--) {
          const item = data[i]
          if (item.followupdate) item.followupdate = new Date(item.followupdate)
          item.created = item.created ? new Date(item.created) : null

          if (isToday(item.followupdate) && item.status !== "Completed") this.followUpToday.unshift(item)
          if (isPastDue(item.followupdate) && item.status !== "Completed") this.pastDue.unshift(item)

          if (item.status === "Pending") {
            item.status = "Open"
            this.internalTaskPending.unshift(item)
            this.internalTaskRequested.unshift(item)
          } else if (item.status === "Requested") {
            item.status = "Assigned"
            this.internalTaskRequested.unshift(item)
          } else if (item.status === "In Process") {
            this.internalTaskRequested.unshift(item)
          }
        }

        this.internalTaskPendingTotal = this.internalTaskPending.length
        this.internalTaskRequestedTotal = this.internalTaskRequested.length
        this.followUpTodayTotal = this.followUpToday.length
        this.pastDueTotal = this.pastDue.length
      } finally {
        if (timer) clearTimeout(timer)
        this.isLoanLoading = false
      }
    },

    async fetchTasksIAssigned() {
      const res = await apiService.GetTasksIAssigned(this.azureId, this.accessToken)
      this.tasksIAssigned = res?.data?.data?.data ?? res?.data?.data ?? []
      this.tasksIAssignedTotal = this.tasksIAssigned.length
    },

    async fetchTeamTasks() {
      const res = await apiService.GetTeamTasks(this.azureId, this.accessToken)
      this.teamTasks = res?.data?.data?.data ?? res?.data?.data ?? []
      this.teamTasksTotal = this.teamTasks.length
    },

    openBorrowerOutstanding() {
      this.$emit("open-grid", {
        title: "Outstanding Tasks",
        data: this.groupByLoanBorrower(this.openTaskRequested),
        columns: this.openTaskColumns,
        sendNotiButton: true,
        dialogType: "borrowerTaskGrouped"
      })
    },
    openBorrowerPending() {
      this.$emit("open-grid", {
        title: "Pending Tasks",
        data: this.groupByLoanBorrower(this.openTaskPending),
        columns: this.openTaskColumns,
        sendNotiButton: true,
        dialogType: "borrowerTaskGrouped"
      })
    },
    openBorrowerSignature() {
      this.$emit("open-grid", {
        title: "Pending Borrower Signature",
        data: this.groupByLoanBorrower(this.openSigningTaskData),
        columns: this.openTaskColumns,
        sendNotiButton: true,
        dialogType: "borrowerTaskGrouped"
      })
    },

    openLoanDueToday() {
      this.$emit("open-grid", {
        title: "Due Today",
        data: this.groupByLoanBorrower(this.followUpToday),
        columns: this.internalTaskColumns,
        dialogType: "internalTaskGrouped"
      })
    },
    openLoanPastDue() {
      this.$emit("open-grid", {
        title: "Past Due",
        data: this.groupByLoanBorrower(this.pastDue),
        columns: this.internalTaskColumns,
        dialogType: "internalTaskGrouped"
      })
    },
    openLoanOpen() {
      this.$emit("open-grid", {
        title: "Open Loan Tasks",
        data: this.groupByLoanBorrower(this.internalTaskPending),
        columns: this.internalTaskColumns,
        dialogType: "internalTaskGrouped"
      })
    },
    openLoanOutstanding() {
      this.$emit("open-grid", {
        title: "Outstanding Loan Tasks",
        data: this.groupByLoanBorrower(this.internalTaskRequested),
        columns: this.internalTaskColumns,
        dialogType: "internalTaskGrouped"
      })
    },
    openLoanAssigned() {
      this.$emit("open-grid", {
        title: "Tasks I Assigned",
        data: this.groupByLoanBorrower(this.tasksIAssigned),
        columns: this.internalTaskColumns,
        dialogType: "internalTaskGrouped"
      })
    },
    openLoanTeam() {
      this.$emit("open-grid", {
        title: "Team Tasks",
        data: this.groupByLoanBorrower(this.teamTasks),
        columns: this.internalTaskColumns,
        dialogType: "internalTaskGrouped"
      })
    }
  },
  async mounted() {
    await this.refreshAll()
  }
}
</script>

<style src="@/assets/css/commandcenter/commandcenter.css"></style>
<style scoped>
.mt-group.divider {
  border-left: 1px solid rgba(15, 23, 42, 0.08);
  margin-left: 5px;
  padding-left: 5px;
}

@media (max-width: 860px) {
  .mt-group.divider {
    border-left: none;
    padding-left: 0;
    margin-left: 0;
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid rgba(15, 23, 42, 0.1);
  }
}
</style>
